<template>
  <h1 class="text-2xl font-bold">{{ $t('nav.updateBusinessAccountInformation') }}</h1>
  <template v-if="!loadingDetail">
    <div class="mt-4 grid grid-cols-2 gap-5">
      <TextField
        ref="name_tk"
        :label="$t('page.name') + ' TM'"
        :required="true"
        name="name_tk"
        :defaultSingleValue="formData?.name_tk"
      ></TextField>
      <TextField
        ref="name_ru"
        :label="$t('page.name') + ' RU'"
        :required="true"
        name="name_ru"
        :defaultSingleValue="formData?.name_ru"
      ></TextField>

      <div class="flex flex-col gap-2">
        <label for="message" class="font-semibold">{{ $t('page.info') }} TM</label>
        <Field
          v-model="formData.description_tk"
          as="textarea"
          name="description_tk"
          id="description_tk"
          :maxlength="$store.setting.max_publication_description_length"
          cols="30"
          rows="6"
          class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4"
        >
        </Field>
        <ErrorMessage name="description_tk" class="text-red-500"></ErrorMessage>
      </div>

      <div class="flex flex-col gap-2">
        <label for="message" class="font-semibold">{{ $t('page.info') }} RU</label>
        <Field
          v-model="formData.description_ru"
          as="textarea"
          name="description_ru"
          id="description_ru"
          :maxlength="$store.setting.max_publication_description_length"
          cols="30"
          rows="6"
          class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4"
        >
        </Field>
        <ErrorMessage name="description_ru" class="text-red-500"></ErrorMessage>
      </div>

      <TextField
        ref="caption_tk"
        :label="$t('page.caption') + ' TM'"
        :required="true"
        name="caption_tm"
        :defaultSingleValue="formData.caption_tk"
      ></TextField>
      <TextField
        ref="caption_ru"
        :label="$t('page.caption') + ' RU'"
        :required="true"
        name="caption_ru"
        :defaultSingleValue="formData.caption_ru"
      ></TextField>

      <SelectFieldSimple
        ref="business_type"
        :label="$t('page.jobType')"
        :required="true"
        name="businessType"
        :options="businessTypes"
        :defaultSelectValue="businessTypes?.find(el => formData.business_type_id == el.id)"
      ></SelectFieldSimple>

      <SelectFieldSimple
        ref="category"
        :label="$t('page.category')"
        :required="true"
        name="category"
        :options="categories"
        :defaultSingleValue="formData.category_id"
        :defaultSelectValue="categories?.find(el => formData.category_id == el.id)"
      ></SelectFieldSimple>

      <TextField
        ref="phone"
        :label="$t('form.phone')"
        :required="true"
        name="phone"
        placeholder="+993"
        :defaultSingleValue="formData.phone"
      ></TextField>

      <TextField
        ref="website"
        :label="$t('page.website')"
        :required="false"
        name="link"
        :defaultSingleValue="formData.link"
      ></TextField>

      <div class="flex flex-col gap-5">
        <LocationNestedSelectField
          v-if="$store.locations"
          ref="location"
          :defaultChildValue="formData.location_id"
          :defaultParentValue="formData?.region_id"
          :label="$t('form.address')"
          :options="$store.locations"
          name="district"
        ></LocationNestedSelectField>
      </div>

      <TextField
        ref="address_tk"
        :label="`${$t('page.address')} TM`"
        :required="true"
        name="address_tk"
        :defaultSingleValue="formData.address_tk"
      ></TextField>

      <TextField
        ref="address_ru"
        :label="`${$t('page.address')} RU`"
        :required="true"
        name="address_ru"
        :defaultSingleValue="formData.address_ru"
      ></TextField>
    </div>

    <hr class="my-4" />
    <p class="text-lg font-bold">{{ $t('page.phoneNumbers') }}</p>

    <div class="mt-4 grid grid-cols-3 gap-2">
      <TextField
        ref="phone_0"
        :label="$t('form.phone') + ' 1'"
        :defaultSingleValue="formData.phone_numbers[0]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_0"
      ></TextField>
      <TextField
        ref="phone_1"
        :label="$t('form.phone') + ' 2'"
        :defaultSingleValue="formData.phone_numbers[1]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_1"
      ></TextField>
      <TextField
        ref="phone_2"
        :label="$t('form.phone') + ' 3'"
        :defaultSingleValue="formData.phone_numbers[2]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_2"
      ></TextField>
      <TextField
        ref="phone_3"
        :label="$t('form.phone') + ' 4'"
        :defaultSingleValue="formData.phone_numbers[3]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_3"
      ></TextField>
      <TextField
        ref="phone_4"
        :label="$t('form.phone') + ' 5'"
        :defaultSingleValue="formData.phone_numbers[4]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_4"
      ></TextField>
      <TextField
        ref="phone_5"
        :label="$t('form.phone') + ' 6'"
        :defaultSingleValue="formData.phone_numbers[5]?.phone"
        :required="false"
        placeholder="+993"
        name="phone_5"
      ></TextField>
    </div>

    <hr class="my-4" />
    <p class="text-lg font-bold">{{ $t('page.contactsSocialMedia') }}</p>

    <div class="mt-4 grid grid-cols-3 gap-2">
      <TextField
        ref="contact_0"
        :label="CONTACT_TYPE_OPTIONS[0]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 0)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[0]"
      ></TextField>
      <TextField
        ref="contact_2"
        :label="CONTACT_TYPE_OPTIONS[2]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 2)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[2]"
      ></TextField>
      <TextField
        ref="contact_3"
        :label="CONTACT_TYPE_OPTIONS[3]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 3)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[3]"
      ></TextField>
      <TextField
        ref="contact_4"
        :label="CONTACT_TYPE_OPTIONS[4]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 4)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[4]"
      ></TextField>
      <TextField
        ref="contact_5"
        :label="CONTACT_TYPE_OPTIONS[5]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 5)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[5]"
      ></TextField>

      <TextField
        ref="contact_6"
        :label="CONTACT_TYPE_OPTIONS[6]"
        :defaultSingleValue="formData.contacts.find(contact => contact.type === 6)?.value"
        :required="false"
        :name="CONTACT_TYPE_OPTIONS[6]"
      ></TextField>
    </div>

    <hr class="my-4" />
    <p class="text-lg font-bold">{{ $t('page.workingHours') }}</p>

    <div class="mt-4 grid grid-cols-3 gap-2">
      <div class="flex flex-col gap-2">
        <TextField
          ref="monday_tk"
          :label="$t('page.monday') + ' TM'"
          :defaultSingleValue="formData.work_hours.monday_tk"
          :required="true"
          placeholder="09:00-18:00"
          name="monday_tk"
        ></TextField>
        <TextField
          ref="monday_ru"
          :label="$t('page.monday') + ' RU'"
          :defaultSingleValue="formData.work_hours.monday_ru"
          :required="true"
          placeholder="09:00-18:00"
          name="monday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="tuesday_tk"
          :label="$t('page.tuesday') + ' TM'"
          :defaultSingleValue="formData.work_hours.tuesday_tk"
          :required="true"
          name="tuesday_tk"
        ></TextField>
        <TextField
          ref="tuesday_ru"
          :label="$t('page.tuesday') + ' RU'"
          :defaultSingleValue="formData.work_hours.tuesday_ru"
          :required="true"
          name="tuesday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="wednesday_tk"
          :label="$t('page.wednesday') + ' TM'"
          :defaultSingleValue="formData.work_hours.wednesday_tk"
          :required="true"
          name="wednesday_tk"
        ></TextField>
        <TextField
          ref="wednesday_ru"
          :label="$t('page.wednesday') + ' RU'"
          :defaultSingleValue="formData.work_hours.wednesday_ru"
          :required="true"
          name="wednesday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="thursday_tk"
          :label="$t('page.thursday') + ' TM'"
          :defaultSingleValue="formData.work_hours.thursday_tk"
          :required="true"
          name="thursday_tk"
        ></TextField>
        <TextField
          ref="thursday_ru"
          :label="$t('page.thursday') + ' RU'"
          :defaultSingleValue="formData.work_hours.thursday_ru"
          :required="true"
          name="thursday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="friday_tk"
          :label="$t('page.friday') + ' TM'"
          :defaultSingleValue="formData.work_hours.friday_tk"
          :required="true"
          name="friday_tk"
        ></TextField>
        <TextField
          ref="friday_ru"
          :label="$t('page.friday') + ' RU'"
          :defaultSingleValue="formData.work_hours.friday_ru"
          :required="true"
          name="friday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="saturday_tk"
          :label="$t('page.saturday') + ' TM'"
          :defaultSingleValue="formData.work_hours.saturday_tk"
          :required="true"
          name="saturday_tk"
        ></TextField>
        <TextField
          ref="saturday_ru"
          :label="$t('page.saturday') + ' RU'"
          :defaultSingleValue="formData.work_hours.saturday_ru"
          :required="true"
          name="saturday_ru"
        ></TextField>
      </div>

      <div class="flex flex-col gap-2">
        <TextField
          ref="sunday_tk"
          :label="$t('page.sunday') + ' TM'"
          :defaultSingleValue="formData.work_hours.sunday_tk"
          :required="true"
          placeholder="Işlänok"
          name="sunday_tk"
        ></TextField>
        <TextField
          ref="sunday_ru"
          :label="$t('page.sunday') + ' RU'"
          :defaultSingleValue="formData.work_hours.sunday_ru"
          :required="true"
          placeholder="Не рабочий день"
          name="sunday_ru"
        ></TextField>
      </div>
    </div>

    <!-- THUMBNAIL PICTURE (Baş surat) -->
    <hr class="my-4" />
    <div class="w-full flex flex-col gap-2 mt-4">
      <p class="font-semibold">
        {{ $t('page.thumbnailPicture') }}
        <span class="text-red-500">*</span>
      </p>

      <div class="flex items-center gap-4">
        <input
          ref="thumbnailInput"
          class="hidden"
          type="file"
          accept=".jpg,.jpeg,.png"
          @change="onThumbnailChange"
        />

        <button
          type="button"
          class="flex gap-3 items-center bg-ml-secondary text-main-color rounded-md cursor-pointer py-3 px-5 hover:bg-ml-main active:bg-ml-main"
          @click="$refs.thumbnailInput.click()"
          :disabled="loadingThumbnail"
        >
          <IconUpload />
          {{ $t('page.uploadImage') }}
        </button>

        <InlineLoader class="!w-8 !h-8" :showLoader="loadingThumbnail" />

        <button
          v-if="thumbnailId"
          type="button"
          class="bg-[#EB5757] text-white px-4 py-2 rounded hover:opacity-90"
          @click="removeThumbnail"
        >
          {{ $t('page.remove') }}
        </button>
      </div>

      <!-- preview: сначала выбранный, иначе текущий с сервера -->
      <div v-if="thumbnailPreview || formData?.thumbnail" class="mt-2">
        <img
          :src="thumbnailPreview || formData.thumbnail"
          class="h-28 w-48 object-contain rounded border"
          alt="thumbnail-preview"
        />
      </div>
    </div>

    <hr class="my-4" />
    <div class="w-full flex flex-col gap-2 mt-4">
      <p class="font-semibold">
        {{ $t('page.uploadImage') }} ({{ imageFiles.length }}/{{ getMaxImageCount }})
      </p>
      <div
        @dragover="dragoverImage"
        @dragleave="dragleaveImage"
        @drop="dropImage"
        class="flex justify-center items-center flex-col border-4 border-dashed border-ml-input-100 p-20"
        :class="{ 'bg-ml-input-200': isDraggingImage }"
      >
        <input
          :disabled="imageFiles.length === getMaxImageCount"
          ref="imageFile"
          name="files"
          class="hidden"
          type="file"
          multiple
          id="imageFileUpload"
          @change="onImageFileChange"
          accept=".jpg,.jpeg,.png"
        />
        <InlineLoader class="!w-8 !h-8" :showLoader="loadingImage"></InlineLoader>
        <label
          v-if="!loadingImage"
          class="flex gap-3 items-center bg-ml-secondary text-main-color rounded-md cursor-pointer py-3 px-5 hover:bg-ml-main active:bg-ml-main"
          for="imageFileUpload"
        >
          <template v-if="imageFiles.length < getMaxImageCount">
            <IconUpload></IconUpload>{{ $t('page.uploadImage') }}
          </template>
          <template v-else>
            <p class="text-blue-500">
              {{ $t('page.maxImage') }}
            </p>
          </template>
        </label>
      </div>
      <p v-if="imageFiles.length == 0" class="text-red-500">{{ $t('warning.imageRequied') }}</p>
    </div>

    <div
      class="grid grid-cols-3 gap-5 mt-4 max-lg:grid-cols-2 max-md:grid-cols-1"
      v-if="imageFiles.length"
    >
      <div
        v-for="file in imageFiles"
        :key="file.detail.name"
        class="w-full flex items-center justify-between p-2 gap-4 border-t border-b"
      >
        <img :src="file.path" alt="uploaded-image" class="h-20 w-32 object-contain" />
        <div class="flex items-center gap-2">
          <a :href="file.path" target="_blank">
            {{ file.detail.name }}
          </a>
        </div>
        <button
          class="ml-3 mt-1 bg-[#EB5757] p-2.5 rounded"
          type="button"
          @click="removeImage(imageFiles.indexOf(file))"
          title="Remove file"
        >
          <IconTrash></IconTrash>
        </button>
      </div>
    </div>

    <div class="w-full flex flex-col gap-2 mt-4">
      <p class="font-semibold">
        {{ $t('page.uploadVideo') }} ({{ videoFiles.length }}/{{ getMaxVideoCount }})
      </p>
      <div
        @dragover="dragoverVideo"
        @dragleave="dragleaveVideo"
        @drop="dropVideo"
        class="flex justify-center items-center flex-col border-4 border-dashed border-ml-input-100 p-20"
        :class="{ 'bg-ml-input-200': isDraggingVideo }"
      >
        <input
          :disabled="videoFiles.length === getMaxVideoCount"
          ref="videoFile"
          name="files"
          class="hidden"
          type="file"
          multiple
          id="videoFileUpload"
          @change="onVideoFileChange"
          accept=".mp4,.mov,.avi,.mkv,.webm"
        />
        <InlineLoader class="!w-8 !h-8" :showLoader="loadingVideo"></InlineLoader>
        <label
          v-if="!loadingVideo"
          class="flex gap-3 items-center bg-ml-secondary text-main-color rounded-md cursor-pointer py-3 px-5 hover:bg-ml-main active:bg-ml-main"
          for="videoFileUpload"
        >
          <template v-if="videoFiles.length < getMaxVideoCount">
            <IconUpload></IconUpload>{{ $t('page.uploadVideo') }}
          </template>
          <template v-else>
            <p class="text-blue-500">
              {{ $t('page.maxVideo') }}
            </p>
          </template>
        </label>
      </div>
    </div>

    <div
      class="grid grid-cols-3 gap-5 mt-4 max-lg:grid-cols-2 max-md:grid-cols-1"
      v-if="videoFiles.length"
    >
      <div
        v-for="file in videoFiles"
        :key="file.detail.name"
        class="w-full flex items-center justify-between p-2 gap-4 border-t border-b"
      >
        <IconMedia class="w-20 h-20"></IconMedia>
        <div class="flex items-center gap-2">
          <a :href="file.path" target="_blank">
            {{ file.detail.name }}
          </a>
        </div>
        <button
          class="ml-3 mt-1 bg-[#EB5757] p-2.5 rounded"
          type="button"
          @click="removeVideo(videoFiles.indexOf(file))"
          title="Remove file"
        >
          <IconTrash></IconTrash>
        </button>
      </div>
    </div>

    <div class="mt-4 mb-20">
      <SubmitBtn @click="onSubmitForm" class="ml-auto">{{ $t('action.send') }}</SubmitBtn>
    </div>
  </template>
</template>

<script>
import api from '@/api';
import TextField from '@cmp/TextField.vue';
import NumberField from '@cmp/NumberField.vue';
import SwitchField from '@cmp/SwitchField.vue';
import SelectFieldSimple from '@cmp/SelectFieldSimple.vue';
import MultiSelectField from '@cmp/MultiSelectField.vue';
import NestedSelectField from '@cmp/NestedSelectField.vue';
import MultiNestedSelectField from '@cmp/MultiNestedSelectField.vue';
import LocationNestedSelectField from '@cmp/LocationNestedSelectField.vue';
import Multiselect from '@vueform/multiselect';

import IconUpload from '@icons/IconUpload.vue';
import IconTrash from '@icons/IconTrash.vue';
import IconMedia from '@icons/IconMedia.vue';

import InlineLoader from '@cmp/InlineLoader.vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import { useField } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { i18n } from '@/i18n';
import { CONTACT_TYPE_OPTIONS } from '@/constants';
import { mapState } from 'pinia';
import { useAppStore } from '@/store';

export default {
  name: 'updateMyBusinessAccount',

  components: {
    TextField,
    SwitchField,
    MultiSelectField,
    MultiNestedSelectField,
    LocationNestedSelectField,
    SelectFieldSimple,
    NumberField,
    Multiselect,
    NestedSelectField,
    Field,
    Form,
    ErrorMessage,
    IconUpload,
    InlineLoader,
    IconTrash,
    IconMedia,
  },

  data() {
    return {
      store: useAppStore(),
      submitting: false,
      loading: false,
      loadingDetail: false,
      thumbnailFile: null,
      thumbnailPreview: null,
      thumbnailId: null,
      loadingThumbnail: false,
      loadingImage: false,
      loadingVideo: false,
      locations: [],
      isDraggingImage: false,
      isDraggingVideo: false,
      imageFiles: [],
      videoFiles: [],
      imageFileIds: [],
      videoFileIds: [],
      newImageFileIds: [],
      newVideoFileIds: [],
      businessTypes: [],
      categories: [],
      currentId: null,
      CONTACT_TYPE_OPTIONS: CONTACT_TYPE_OPTIONS,
      config: {},

      formData: {
        name_tk: '',
        name_ru: '',
        thumbnail: '',
        description_tk: '',
        description_ru: '',
        caption_tk: '',
        caption_ru: '',
        business_type: null,
        business_type_id: null,
        category_id: null,
        phone: null,
        link: null,
        address_tk: null,
        address_ru: null,
        region_id: null,
        location_id: null,
        location: null,
        phones: [],
        work_hours: {
          monday_tk: '',
          monday_ru: '',
          tuesday_tk: '',
          tuesday_ru: '',
          wednesday_tk: '',
          wednesday_ru: '',
          thursday_tk: '',
          thursday_ru: '',
          friday_tk: '',
          friday_ru: '',
          saturday_tk: '',
          saturday_ru: '',
          sunday_tk: '',
          sunday_ru: '',
        },
        contacts: [],
        phone_numbers: [],
      },
      resetKey: 0,
      initialPayloadHash: null,
      initialHashReady: false,
    };
  },

  methods: {
    diffKeys(a, b, prefix = '') {
      const changed = new Set();

      // примитивы / null
      if (a === null || a === undefined || b === null || b === undefined) {
        if (a !== b) changed.add(prefix || 'root');
        return changed;
      }

      // массивы
      if (Array.isArray(a) || Array.isArray(b)) {
        const aa = Array.isArray(a) ? a : [];
        const bb = Array.isArray(b) ? b : [];
        if (JSON.stringify(aa) !== JSON.stringify(bb)) changed.add(prefix || 'root');
        return changed;
      }

      // объекты
      if (typeof a === 'object' && typeof b === 'object') {
        const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
        for (const k of keys) {
          const p = prefix ? `${prefix}.${k}` : k;
          const sub = this.diffKeys(a[k], b[k], p);
          sub.forEach(x => changed.add(x));
        }
        return changed;
      }

      // строки/числа/булевы
      if (a !== b) changed.add(prefix || 'root');
      return changed;
    },

    isOnlyFastFieldsChanged(initialComparable, currentComparable) {
      const changed = this.diffKeys(initialComparable, currentComparable);

      // ✅ Разрешённые поля для обхода модерации
      // В buildComparableBusinessPayload() они называются:
      // business_type, category, phone, location, phone_numbers
      const allowedPrefixes = ['business_type', 'category', 'phone', 'location', 'phone_numbers'];

      // убираем "root" если вдруг появился
      const cleaned = Array.from(changed).filter(x => x && x !== 'root');

      // если вообще нет изменений — не сюда (это уже обработано хешем)
      if (!cleaned.length) return false;

      // ✅ все изменённые ключи должны попадать в белый список (по префиксу)
      return cleaned.every(key => allowedPrefixes.some(p => key === p || key.startsWith(p + '.')));
    },

    normalizeBool(v) {
      if (v === true || v === false) return v;
      if (v === 1 || v === '1') return true;
      if (v === 0 || v === '0') return false;

      if (typeof v === 'string') {
        const s = v.trim().toLowerCase();
        if (['true', 'yes', 'on'].includes(s)) return true;
        if (['false', 'no', 'off', ''].includes(s)) return false;
      }
      return !!v;
    },

    normalizeId(v) {
      if (v === undefined || v === null) return null;
      if (typeof v === 'object') return v.id ?? v.value ?? null;
      return v;
    },

    buildComparableBusinessPayload() {
      // normalize location exactly like submit
      const locVal = this.formData.location ?? this.formData.location_id;

      const locationId = Array.isArray(locVal)
        ? locVal.length > 1
          ? locVal[1]
          : locVal[0]
        : locVal;

      // phone_numbers: trim + drop empties (как в payload)
      const phone_numbers = (this.formData.phone_numbers || [])
        .map((p, idx) => ({
          phone: String(p?.phone ?? '').trim(),
          order: Number(p?.order ?? idx + 1),
        }))
        .filter(p => p.phone !== '')
        .sort((a, b) => a.order - b.order);

      // contacts: trim + drop empties (как в payload)
      const contacts = (this.formData.contacts || [])
        .map(c => ({
          type: Number(c?.type),
          value: String(c?.value ?? '').trim(),
          order: Number(c?.order ?? Number(c?.type) + 1),
        }))
        .filter(c => c.value !== '')
        .sort((a, b) => a.type - b.type);

      // work_hours: стабилизируем ключи + trim
      const wh = this.formData.work_hours || {};
      const work_hours = {
        monday_tk: String(wh.monday_tk ?? '').trim(),
        monday_ru: String(wh.monday_ru ?? '').trim(),
        tuesday_tk: String(wh.tuesday_tk ?? '').trim(),
        tuesday_ru: String(wh.tuesday_ru ?? '').trim(),
        wednesday_tk: String(wh.wednesday_tk ?? '').trim(),
        wednesday_ru: String(wh.wednesday_ru ?? '').trim(),
        thursday_tk: String(wh.thursday_tk ?? '').trim(),
        thursday_ru: String(wh.thursday_ru ?? '').trim(),
        friday_tk: String(wh.friday_tk ?? '').trim(),
        friday_ru: String(wh.friday_ru ?? '').trim(),
        saturday_tk: String(wh.saturday_tk ?? '').trim(),
        saturday_ru: String(wh.saturday_ru ?? '').trim(),
        sunday_tk: String(wh.sunday_tk ?? '').trim(),
        sunday_ru: String(wh.sunday_ru ?? '').trim(),
      };

      // banners ids: фото+видео
      const uniq = arr => Array.from(new Set(arr));
      const banners = uniq([...(this.imageFileIds || []), ...(this.videoFileIds || [])])
        .map(Number)
        .filter(Number.isFinite)
        .sort((a, b) => a - b);

      // thumbnail: если выбрали новый — сравниваем по id, иначе по текущему URL (как “не меняли”)
      const effectiveThumbnail = this.thumbnailId
        ? { id: Number(this.thumbnailId) }
        : { url: String(this.formData.thumbnail ?? '').trim() };

      return {
        origin: Number(this.currentId),

        name_tk: String(this.formData.name_tk ?? '').trim(),
        name_ru: String(this.formData.name_ru ?? '').trim(),
        description_tk: String(this.formData.description_tk ?? '').trim(),
        description_ru: String(this.formData.description_ru ?? '').trim(),
        caption_tk: String(this.formData.caption_tk ?? '').trim(),
        caption_ru: String(this.formData.caption_ru ?? '').trim(),

        business_type: Number(this.formData.business_type_id ?? this.formData.business_type ?? 0),
        category: Number(this.formData.category_id ?? this.formData.category ?? 0),

        phone: String(this.formData.phone ?? '').trim(),
        link: String(this.formData.link ?? '').trim(),
        address_tk: String(this.formData.address_tk ?? '').trim(),
        address_ru: String(this.formData.address_ru ?? '').trim(),

        // region_id не отправляется — но для “ничего не поменял” можно игнорировать
        location: locationId ? Number(locationId) : null,

        phone_numbers,
        contacts,
        work_hours,

        banners,
        thumbnail: effectiveThumbnail,
      };
    },

    hashBusinessPayload(obj) {
      return JSON.stringify(obj);
    },

    async captureInitialBusinessHash() {
      // на всякий, чтобы все данные точно уже легли
      await this.$nextTick();
      const comparable = this.buildComparableBusinessPayload();
      this.initialPayloadHash = this.hashBusinessPayload(comparable);
      this.initialHashReady = true;
    },

    async hasExistingRequestForOrigin(originId) {
      try {
        let url = 'posts/my-business_account-requests/';
        const target = Number(originId);

        // Пагинация: results + next (DRF)
        while (url) {
          const res = await api.get(url);
          const data = res?.data;

          const items = Array.isArray(data) ? data : data?.results || [];
          const found = items.some(item => {
            const origin = typeof item?.origin === 'object' ? item?.origin?.id : item?.origin;
            return Number(origin) === target;
          });

          if (found) return true;

          // next может быть абсолютным URL — axios нормально его съест
          url = data?.next || null;
        }
      } catch (e) {
        // если проверка не удалась — не блокируем отправку
      }
      return false;
    },

    async onThumbnailChange(e) {
      const file = e.target.files?.[0];
      if (!file) return;

      if (this.thumbnailPreview) URL.revokeObjectURL(this.thumbnailPreview);

      this.thumbnailFile = file;
      this.thumbnailPreview = URL.createObjectURL(file);
      this.thumbnailId = null;

      try {
        this.loadingThumbnail = true;

        const fd = new FormData();
        fd.append('path', file);

        const res = await api.post('files/medias/', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (res && res.status === 201) {
          this.thumbnailId = res.data.id;
          if (this.$refs.thumbnailInput) this.$refs.thumbnailInput.value = '';
        } else {
          this.$toast.warning(`${i18n.global.t('warning.UPLOAD_FAILED')}`);
          this.thumbnailPreview = null;
          this.thumbnailFile = null;
        }
      } catch (err) {
        console.log(err);
        this.$toast.warning(`${i18n.global.t('warning.UPLOAD_FAILED')}`);
        this.thumbnailPreview = null;
        this.thumbnailFile = null;
      } finally {
        this.loadingThumbnail = false;
      }
    },

    removeThumbnail() {
      if (this.thumbnailPreview) URL.revokeObjectURL(this.thumbnailPreview);
      this.thumbnailId = null;
      this.thumbnailFile = null;
      this.thumbnailPreview = null;
      if (this.$refs.thumbnailInput) this.$refs.thumbnailInput.value = '';
    },

    dragoverImage(e) {
      e.preventDefault();
      this.isDraggingImage = true;
    },
    dragleaveImage() {
      this.isDraggingImage = false;
    },
    dropImage(e) {
      e.preventDefault();
      this.$refs.imageFile.files = e.dataTransfer.files;
      this.onImageFileChange();
      this.isDraggingImage = false;
    },

    async onImageFileChange() {
      const files = Array.from(this.$refs.imageFile?.files || []);
      const allowed = this.getMaxImageCount - this.imageFiles.length;

      if (allowed <= 0) {
        this.$toast.info(`${this.$t('page.maxImage')} (${this.getMaxImageCount})`);
        if (this.$refs.imageFile) this.$refs.imageFile.value = '';
        return;
      }

      const slice = files.slice(0, allowed);
      if (slice.length < files.length) {
        this.$toast.info(`${this.$t('page.maxImage')} (${this.getMaxImageCount})`);
      }

      this.loadingImage = true;
      try {
        for (let x = 0; x < slice.length; x++) {
          const f = slice[x];
          const fileForm = new FormData();
          fileForm.append('path', f);

          const response = await api.post('files/medias/', fileForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          if (response && response.status === 201) {
            this.imageFiles.push({
              detail: f,
              path: URL.createObjectURL(f),
              isUploaded: true,
            });
            this.imageFileIds.push(response.data.id);
            this.newImageFileIds.push(response.data.id);
          } else {
            this.$toast.warning(`${i18n.global.t('warning.UPLOAD_FAILED')}`);
          }
        }
      } finally {
        this.loadingImage = false;
        if (this.$refs.imageFile) this.$refs.imageFile.value = '';
      }
    },

    dragoverVideo(e) {
      e.preventDefault();
      this.isDraggingVideo = true;
    },
    dragleaveVideo() {
      this.isDraggingVideo = false;
    },
    dropVideo(e) {
      e.preventDefault();
      this.$refs.videoFile.files = e.dataTransfer.files;
      this.onVideoFileChange();
      this.isDraggingVideo = false;
    },

    async onVideoFileChange() {
      const files = Array.from(this.$refs.videoFile?.files || []);
      const allowed = this.getMaxVideoCount - this.videoFiles.length;

      if (allowed <= 0) {
        this.$toast.info(`${this.$t('page.maxVideo')} (${this.getMaxVideoCount})`);
        if (this.$refs.videoFile) this.$refs.videoFile.value = '';
        return;
      }

      const slice = files.slice(0, allowed);
      if (slice.length < files.length) {
        this.$toast.info(`${this.$t('page.maxVideo')} (${this.getMaxVideoCount})`);
      }

      this.loadingVideo = true;
      try {
        for (let x = 0; x < slice.length; x++) {
          const f = slice[x];

          const fileForm = new FormData();
          fileForm.append('path', f);

          const response = await api.post('files/medias/', fileForm, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          if (response && response.status === 201) {
            this.videoFiles.push({
              detail: f,
              path: URL.createObjectURL(f),
              isUploaded: true,
            });
            this.videoFileIds.push(response.data.id);
            this.newVideoFileIds.push(response.data.id);
          } else {
            this.$toast.warning(`${i18n.global.t('warning.UPLOAD_FAILED')}`);
          }
        }
      } catch (e) {
        console.log(e);
        this.$toast.warning(`${i18n.global.t('warning.UPLOAD_FAILED')}`);
      } finally {
        this.loadingVideo = false;
        if (this.$refs.videoFile) this.$refs.videoFile.value = '';
      }
    },

    async removeImage(i) {
      const mediaId = this.imageFileIds[i];

      this.imageFiles.splice(i, 1);
      this.imageFileIds.splice(i, 1);

      if (!mediaId) return;

      const idx = this.newImageFileIds.indexOf(mediaId);
      if (idx !== -1) {
        this.newImageFileIds.splice(idx, 1);

        try {
          await api.delete(`files/medias/${mediaId}/`);
        } catch (e) {
          console.log(e);
          // можно тост, но лучше не шуметь
        }
      }
    },

    async removeVideo(i) {
      const mediaId = this.videoFileIds[i];

      this.videoFiles.splice(i, 1);
      this.videoFileIds.splice(i, 1);

      if (!mediaId) return;

      const idx = this.newVideoFileIds.indexOf(mediaId);
      if (idx !== -1) {
        this.newVideoFileIds.splice(idx, 1);

        try {
          await api.delete(`files/medias/${mediaId}/`);
        } catch (e) {
          console.log(e);
        }
      }
    },

    async getLocations() {
      this.loading = true;
      try {
        const response = await api.get(`locations/`);
        this.locations = response.data;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    isVideo(path) {
      let conditions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];
      const fragments = path.toLowerCase().split('.');
      const extension = `.${fragments[fragments.length - 1]}`;
      return conditions.includes(extension);
    },

    findParentById(data, childId) {
      if (!Array.isArray(data)) return null;

      for (const item of data) {
        const children = Array.isArray(item.children) ? item.children : [];

        if (children.some(child => child.id === childId)) {
          return item;
        }

        const found = this.findParentById(children, childId);
        if (found) return found;
      }
      return null;
    },

    async getBusinessAccountDetail() {
      this.loadingDetail = true;
      try {
        const response = await api.get(
          `posts/my-business-accounts/${this.currentId}/?include_translations=True`,
        );
        this.formData.thumbnail = response.data.thumbnail || '';
        this.formData.subscription = response.data.subscription;

        this.formData.name_tk = response.data.name_tk;
        this.formData.name_ru = response.data.name_ru;
        this.formData.description_tk = response.data.description_tk;
        this.formData.description_ru = response.data.description_ru;
        this.formData.caption_tk = response.data.caption_tk;
        this.formData.caption_ru = response.data.caption_ru;
        this.formData.category_id = response.data.category_id;
        this.formData.business_type_id = response.data.business_type_id;
        this.formData.link = response.data.link;
        this.formData.phone = response.data.phone;
        // New backend returns both variants with include_translations=True.
        // Fallback keeps this page usable during a rolling frontend/backend deploy.
        this.formData.address_tk = response.data.address_tk ?? response.data.address ?? '';
        this.formData.address_ru = response.data.address_ru ?? response.data.address ?? '';

        const parent = this.findParentById(this.locations, response.data.location_id);
        this.formData.region_id = parent ? parent.id : null;

        this.formData.location_id = response.data.location_id;
        this.formData.work_hours = response.data.work_hours;

        this.formData.phone_numbers = Array(6)
          .fill({ phone: '', order: null })
          .map((_, index) => {
            const match = response.data.phone_numbers.find(p => p.order === index + 1);
            return match
              ? { phone: match.phone, order: match.order }
              : { phone: '', order: index + 1 };
          });

        this.formData.contacts = Object.keys(CONTACT_TYPE_OPTIONS).map(type => ({
          type: parseInt(type),
          value: '',
          order: parseInt(type) + 1,
        }));

        const mappedContacts = this.formData.contacts.map(item => {
          const matchedContact = response.data.contacts.find(contact => contact.type === item.type);
          return {
            ...item,
            value: matchedContact ? matchedContact.value : item.value,
          };
        });
        this.formData.contacts = mappedContacts;

        response.data.banners.forEach(element => {
          if (this.isVideo(element.path)) {
            const items = element.path.split('/');
            this.videoFiles.push({
              detail: { name: items[items.length - 1] },
              path: element.path,
              isUploaded: true,
            });

            this.videoFileIds.push(element.id);
          } else {
            const items = element.path.split('/');
            this.imageFiles.push({
              detail: { name: items[items.length - 1] },
              path: element.path,
              isUploaded: true,
            });
            this.imageFileIds.push(element.id);
          }
        });

        this.formData.location = null;

        await this.captureInitialBusinessHash();
      } catch (e) {
        console.log(e);
      }
      this.loadingDetail = false;
    },

    async getBusinessCategories() {
      try {
        const response = await api.get('posts/business_accounts/categories/');
        this.categories = response.data;
      } catch (e) {
        console.log(e);
      }
    },

    async getBusinessTypes() {
      try {
        const response = await api.get('posts/business_types/');
        this.businessTypes = response.data;
      } catch (e) {
        console.log(e);
      }
    },

    async onSubmitForm() {
      if (this.submitting) return;
      this.submitting = true;

      try {
        const isValid = [];

        // ✅ 1) VALIDATION
        for (const refName of Object.keys(this.$refs)) {
          const field = this.$refs[refName];

          if (field && typeof field.validateField === 'function') {
            const validation = await field.validateField();

            if (validation.valid) {
              if (refName.startsWith('phone_')) {
                const idx = Number(refName.split('_')[1]);
                if (!this.formData.phone_numbers[idx]) {
                  this.formData.phone_numbers[idx] = { phone: '', order: idx + 1 };
                }
                this.formData.phone_numbers[idx].phone = validation.value;
                this.formData.phone_numbers[idx].order = idx + 1;
              } else if (refName.startsWith('contact_')) {
                const type = Number(refName.split('_')[1]);
                const i = (this.formData.contacts || []).findIndex(c => Number(c.type) === type);
                if (i !== -1) this.formData.contacts[i].value = validation.value;
              } else if (refName === 'location') {
                this.formData.location = validation.value;
              } else if (this.formData.work_hours && refName in this.formData.work_hours) {
                this.formData.work_hours[refName] = validation.value;
              } else if (refName === 'business_type') {
                const id = this.normalizeId(validation.value);
                if (id !== null && id !== undefined && id !== '') {
                  this.formData.business_type_id = id;
                  this.formData.business_type = id;
                }
              } else if (refName === 'category') {
                const id = this.normalizeId(validation.value);
                if (id !== null && id !== undefined && id !== '') {
                  this.formData.category_id = id;
                  this.formData.category = id;
                }
              } else if (refName === 'website') {
                this.formData.link = validation.value;
              } else {
                if (validation.mode) this.formData[refName] = validation.value;
              }
            } else {
              isValid.push(false);
            }
          }
        }

        if (isValid.includes(false)) return;

        // ✅ STOP if nothing changed
        const currentComparable = this.buildComparableBusinessPayload();
        const currentHash = this.hashBusinessPayload(currentComparable);

        if (!this.initialPayloadHash) {
          this.initialPayloadHash = currentHash;
          this.initialHashReady = true;
          this.$toast.info(i18n.global.t('warning.NOTHING_CHANGED') || 'Вы ничего не изменили');
          return;
        }

        if (currentHash === this.initialPayloadHash) {
          this.$toast.info(i18n.global.t('warning.NOTHING_CHANGED') || 'Вы ничего не изменили');
          return;
        }

        const initialComparable = JSON.parse(this.initialPayloadHash);
        const onlyFast = this.isOnlyFastFieldsChanged(initialComparable, currentComparable);

        if (!onlyFast) {
          const exists = await this.hasExistingRequestForOrigin(this.currentId);
          if (exists) {
            this.$toast.warning(i18n.global.t('warning.BA_REQUEST_ALREADY_EXISTS'));
            return;
          }
        }

        // ✅ normalize location
        const locVal = this.formData.location ?? this.formData.location_id;
        const locationId = Array.isArray(locVal)
          ? locVal.length > 1
            ? locVal[1]
            : locVal[0]
          : locVal;

        // ✅ безопасные id для select полей
        const resolvedCategoryId = this.normalizeId(
          this.formData.category ?? this.formData.category_id,
        );
        const resolvedBusinessTypeId = this.normalizeId(
          this.formData.business_type ?? this.formData.business_type_id,
        );

        if (!resolvedCategoryId || !resolvedBusinessTypeId) {
          this.$toast.warning('Категория или тип бизнеса не определены');
          return;
        }

        // ✅ общий payload
        const payload = {
          ...this.formData,
          origin: Number(this.currentId),
          location: locationId,
          banners: [...this.imageFileIds, ...this.videoFileIds],
          category: resolvedCategoryId,
          business_type: resolvedBusinessTypeId,
          // Keep legacy single-address payload for older backend nodes during rolling deploys.
          address: String(this.formData.address_tk || this.formData.address_ru || '').trim(),
        };

        delete payload.category_id;
        delete payload.business_type_id;

        // phone_numbers: trim + drop empties
        payload.phone_numbers = (payload.phone_numbers || [])
          .map((p, idx) => ({
            ...p,
            phone: String(p?.phone ?? '').trim(),
            order: p?.order ?? idx + 1,
          }))
          .filter(p => p.phone !== '');

        // contacts: trim + drop empties
        const filteredContacts = (payload.contacts || [])
          .map(c => ({
            ...c,
            value: String(c?.value ?? '').trim(),
          }))
          .filter(c => c.value !== '');

        if (filteredContacts.length) payload.contacts = filteredContacts;
        else delete payload.contacts;

        if (this.thumbnailId) payload.thumbnail_picture = this.thumbnailId;
        else delete payload.thumbnail_picture;

        delete payload.location_id;
        delete payload.region_id;
        delete payload.thumbnail;

        // ✅ FAST PATCH
        if (onlyFast) {
          const patchPayload = {
            business_type: Number(resolvedBusinessTypeId),
            category: Number(resolvedCategoryId),
            phone: String(payload.phone ?? '').trim(),
            phone_numbers: payload.phone_numbers || [],
          };

          if (payload.location) {
            patchPayload.location = Number(payload.location);
          }

          await api.patch(`posts/my-business-accounts/${this.currentId}/`, patchPayload);

          this.initialPayloadHash = currentHash;
          this.initialHashReady = true;

          this.$toast.success(i18n.global.t('warning.ACCOUNT_UPDATED') || 'Успешно обновлено');
          this.$router.push({ name: 'myBusinessAccounts' });
          return;
        }

        // ✅ через модерацию
        const requestPayload = {
          ...payload,
          category_id_input: Number(resolvedCategoryId),
          business_type_id_input: Number(resolvedBusinessTypeId),
        };

        delete requestPayload.category;
        delete requestPayload.business_type;

        await api.post('posts/my-business_account-requests/', requestPayload);

        this.initialPayloadHash = currentHash;
        this.initialHashReady = true;

        this.$toast.info(i18n.global.t('warning.ACCOUNT_EDIT_REQUESTED'));
        this.$router.push({ name: 'myBusinessAccountsRequests' });
        return;
      } catch (e) {
        console.log(e);
      } finally {
        this.submitting = false;
      }
    },
  },

  computed: {
    ...mapState(useAppStore, ['getSubscriptionSettings']),
    getConfig() {
      return this.getSubscriptionSettings.find(el => el.name === this.formData.subscription);
    },
    getMaxImageCount() {
      return this.getConfig?.business_account_image_count !== undefined
        ? this.getConfig?.business_account_image_count
        : this.$store.setting.max_business_image_count;
    },
    getMaxVideoCount() {
      return this.getConfig?.business_account_video_count !== undefined
        ? this.getConfig?.business_account_video_count
        : this.$store.setting.max_business_video_count;
    },
  },

  created() {
    this.currentId = this.$route.params.id;

    this.getLocations().then(() => {
      this.getBusinessTypes();
      this.getBusinessCategories();
      this.getBusinessAccountDetail();
    });
  },
};
</script>
